import React from 'react';
import styled from 'styled-components';
import RCore from 'RCore';
import color from 'color';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SMTeamLogo from '../SMTeamLogo';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const Container = styled.ul`
    padding: 0 87px;

    .tt-values {
        display: flex;
        min-width: 150px;
    }

    .tt-val {
        color: ${props => props.theme.color};
        text-align: center;
        min-width: 35px;

        &.grow {
            flex-grow: 1;
        }
    }
`;

const LI = styled.li`
    list-style: none;
    margin-bottom: 2px;
    position: relative;
    color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    display: flex;
    align-items: center;
    font-size: 1rem;
    line-height: 1em;
    text-transform: uppercase;
    padding: 6px 25px 6px 32px;
    font-weight: ${props => props.theme.fonts.main.bold};
    background-color: ${props => (props.high ? props.theme.content.accentColor : 'transparent')};

    .tt-logo {
        margin-right: 10px;
    }

    .tt-rank {
        width: 35px;
        text-align: center;
    }

    .tt-team {
        flex-grow: 1;
        align-items: center;
        display: flex;
    }

    tt-rank,
    .tt-team,
    .tt-val {
        color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    }

    .rel-badge {
        display: inline-block;
        background-color: ${props =>
            (props.type && color(props.theme.qualRelColors[props.type]).toString()) ||
            props.theme.content.backgroundColor};
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 9px;
        transform: translateY(-50%);
    }

    &:nth-child(1) {
        .rel-badge {
            display: none;
        }
    }
`;

const HeadLI = LI.extend`
    > div {
        opacity: 0.7;
    }
`;

const Header = ({ qualRel }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <HeadLI>
            {qualRel && <span className="rel-badge" />}
            <div className="tt-rank">#</div>
            <div className="tt-team" />
            <div className="tt-values">
                <div className="tt-val">{i18('matches.short', lang)}</div>
                <div className="tt-val grow">{i18('goals.short', lang)}</div>
                <div className="tt-val">{i18('points.short', lang)}</div>
            </div>
        </HeadLI>
    );
};

const Row = ({ row, tournamentId, qualRel, highlight }) => {
    return (
        <LI type={qualRel && row.rankType} high={highlight}>
            {qualRel && <span className="rel-badge" />}
            <div className="tt-rank">{row.rank}</div>
            <div className="tt-team">
                <SMTeamLogo
                    tournamentId={tournamentId}
                    teamId={row.teamId}
                    width={28}
                    height={28}
                    style={{ marginRight: '10px' }}
                />
                {row.teamName}
            </div>
            <div className="tt-values">
                <div className="tt-val">{row.matchesPlayed}</div>
                <div className="tt-val grow">{row.goalsScored + ' - ' + row.goalsConceded}</div>
                <div className="tt-val">{row.points}</div>
            </div>
        </LI>
    );
};

Row.contextTypes = {
    info: PropTypes.object
};

Header.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/TextTT.js
 **/